import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const BlogDetail = () => {
  const { id } = useParams();
  const [progress, setProgress] = useState(0);

  const blogs = [
    {
      id: "1",
      title: "Top Web Development Trends in 2026",
      img: "https://images.pexels.com/photos/3861969/pexels-photo-3861969.jpeg",
      content: `
The world of web development is evolving rapidly in 2026. Businesses today are no longer satisfied with basic websites — they demand high-performance, scalable and visually appealing digital experiences.

Modern frameworks such as React and Next.js have transformed how developers build applications. These technologies enable faster loading speeds, better SEO performance and highly interactive user interfaces.

One of the biggest trends is the shift towards mobile-first design. With the majority of users accessing websites through mobile devices, responsiveness is no longer optional — it is essential.

Another important trend is the integration of artificial intelligence. From chatbots to personalized recommendations, AI is helping businesses enhance user engagement and improve customer satisfaction.

Security is also a major concern. With increasing cyber threats, developers must ensure proper encryption, secure authentication and data protection practices.

In conclusion, web development in 2026 is all about speed, user experience, scalability and security. Businesses that adopt these trends will stay ahead in the competitive digital landscape.
      `,
    },
    {
      id: "2",
      title: "Why SEO is Important for Business Growth",
      img: "https://images.pexels.com/photos/270348/pexels-photo-270348.jpeg",
      content: `
Search Engine Optimization (SEO) is one of the most powerful tools for growing an online business. It helps websites rank higher on search engines and drives organic traffic without paid advertisements.

A well-optimized website builds credibility and trust among users. When your website appears on the first page of search results, customers are more likely to choose your business over competitors.

SEO involves multiple factors such as keyword research, technical optimization, content creation and link building. It also focuses on improving user experience and website performance.

In today’s competitive market, ignoring SEO means losing potential customers. Businesses that invest in SEO gain long-term visibility and sustainable growth.

Overall, SEO is not just a marketing strategy — it is a necessity for any business aiming to succeed online.
      `,
    },
    {
      id: "3",
      title: "Mobile App vs Website – What Should You Choose?",
      img: "https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg",
      content: `
Choosing between a mobile application and a website depends on your business objectives and target audience.

Websites are cost-effective, accessible on all devices and easier to maintain. They are ideal for businesses that want to establish an online presence quickly.

On the other hand, mobile applications offer a more personalized and engaging user experience. They provide faster performance, push notifications and offline access.

For businesses that require frequent user interaction, apps are a better choice. However, many successful companies use both websites and apps to maximize reach and engagement.

Ultimately, the right choice depends on your goals, budget and user expectations.
      `,
    },
    {
      id: "4",
      title: "Digital Marketing Strategies That Work",
      img: "https://images.pexels.com/photos/905163/pexels-photo-905163.jpeg",
      content: `
Digital marketing has become essential for every business in today’s digital-first world. It helps brands connect with their audience, increase visibility and drive sales.

Effective strategies include social media marketing, search engine optimization, content marketing and paid advertising. Each of these plays a crucial role in building a strong online presence.

Consistency and creativity are key factors in successful digital marketing. Businesses must continuously analyze performance and optimize their campaigns.

Data-driven decisions allow companies to target the right audience and maximize return on investment.

In conclusion, digital marketing is a powerful tool that enables businesses to grow faster and stay ahead of the competition.
      `,
    },
  ];

  const blog = blogs.find((b) => b.id === id);


  useEffect(() => {
    const handleScroll = () => {
      const total =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / total) * 100;
      setProgress(progress);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!blog) return <h1 className="text-center mt-40">Blog Not Found</h1>;

  return (
    <div className="bg-[#f8fafc]">

      {/* PROGRESS BAR */}
      <div
        className="fixed top-0 left-0 h-1 bg-red-600 z-50"
        style={{ width: `${progress}%` }}
      />

      {/* HERO */}
      <div className="relative h-[65vh] flex items-center justify-center">
        <img src={blog.img} alt="" className="absolute w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60"></div>

        <h1 className="relative text-white text-4xl md:text-5xl font-bold text-center px-6 max-w-3xl leading-tight">
          {blog.title}
        </h1>
      </div>

      {/* ARTICLE */}
      <div className="max-w-3xl mx-auto px-6 py-16">

        {/* AUTHOR */}
        <div className="flex items-center gap-4 mb-10 border-b pb-6">
          <img src="https://i.pravatar.cc/100" className="w-12 h-12 rounded-full" />
          <div>
            <p className="font-semibold text-gray-900">Om Internet Services</p>
            <p className="text-sm text-gray-500">Published • 2026 • 5 min read</p>
          </div>
        </div>

        {/* CONTENT */}
        <div className="space-y-6 text-gray-700 text-lg leading-loose">

          {blog.content.split("\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}

        </div>

        {/* CTA */}
        <div className="mt-16 text-center bg-white p-10 rounded-2xl shadow-md">
          <h2 className="text-2xl font-bold text-gray-900">
            Let’s Grow Your Business 🚀
          </h2>
          <p className="text-gray-500 mt-2">
            We build websites, apps & marketing strategies that deliver results.
          </p>
          <Link to="/contact">
            <button className="mt-6 px-8 py-3 bg-red-600 text-white rounded-full hover:bg-red-700 transition">
              Contact Us
            </button>
          </Link>
        </div>

      </div>
    </div>
  );
};

export default BlogDetail;